import templateUrl from './edit-onboarding-document-modal.component.html';
import { ImageCropperModal } from '../../../shared/image-cropper/image-cropper-modal.component';

export const EditOnboardingDocumentModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        dismiss: "&",
        close: "&"
    },
    controller: EditOnboardingDocumentController,
    controllerAs: "vm"
}

function EditOnboardingDocumentController($q, $uibModal, onboardingApplicationService, utilityService, fileService) {
    'ngInject';
    const vm = this;
    vm.$onInit = $onInit;

    vm.isDocumentImage = isDocumentImage;
    vm.allowedExtensions = ".xls,.xlsx,.doc,.docx,.txt,.pdf,.jpg,.jpeg,.png";
    vm.onCancel = onCancel;
    vm.onSave = onSave;
    vm.handleFileSelect = handleFileSelect;
    vm.file;

    function $onInit() {
        vm.documentTitle = vm.resolve.documentTitle;
        vm.onboardingApplicationID = vm.resolve.onboardingApplicationID;
        vm.onboardingDocument = vm.resolve.onboardingDocument;
        vm.onboardingDocumentGroup = vm.resolve.onboardingDocumentGroup;
    }

    function isDocumentImage(document) {
        return document.MimeType.startsWith("image/");
    }

    function onCancel() {
        vm.dismiss({ $value: "cancel" });
    }

    function handleFileSelect(doc, value) {
        if (fileService.isValidImage(value) && doc.UseImageCropper) {
            fileService.fileToDataUrl(value)
                .then(function (dataUrl) {
                    return $uibModal.open({
                        ...ImageCropperModal,
                        resolve: {
                            dataUrl: () => dataUrl,
                            cropHeight: () => 800,
                            cropWidth: () => 450,
                            resultHeight: () => 800,
                            resultWidth: () => 800,
                            areaType: () => "rectangle"
                        }
                    }).result
                        .then(function (data) {
                            if (!data) {
                                return $q.when(null);
                            }
                            return fileService.dataUrlToFile(data, value.name, value.type)
                        }).then(function (file) {
                            if (!file) {
                                vm.file = null;
                            } else {
                                vm.file = file;
                            }
                        });
                });
        }
    }

    function onSave() {
        utilityService.showLoading();
        $q.resolve()
            .then(function () {
                return onboardingApplicationService.updateOnboardingDocument(
                    vm.onboardingDocument.UploadUrl,
                    vm.file);
            })
            .then(function (response) {
                const metadata = response.data;
                vm.onboardingDocument.DownloadUrl = vm.onboardingDocument.UploadUrl;
                vm.onboardingDocument.MimeType = metadata.MimeType;
                vm.close({ $value: true });
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Upload failed: " + utilityService.getExceptionMessage(ex))
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }
}
